import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, useParams, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import ServicesIndex from "@/pages/ServicesIndex";
import ServicePage from "@/pages/ServicePage";
import SectorsIndex from "@/pages/SectorsIndex";
import SectorPage from "@/pages/SectorPage";
import ServiceAreas from "@/pages/ServiceAreas";
import InsightsIndex from "@/pages/InsightsIndex";
import InsightPage from "@/pages/InsightPage";
import About from "@/pages/About";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminApplications from "@/pages/AdminApplications";
import { FrServicesIndex, FrServicePage } from "@/pages/FrServicePages";
import FrHome from "@/pages/FrHome";
import FrVilles from "@/pages/FrVilles";
import { RegionsIndex } from "@/pages/RegionPages";
import RegionPage from "@/pages/RegionPages";
import FlatResolver from "@/pages/FlatResolver";
import { FrResolver } from "@/pages/FrCityPage";
import NotFound from "@/pages/NotFound";
import { regionBySlug } from "@/data/regions";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const FrRoute = () => {
  const { slug } = useParams();
  return <FrResolver slug={slug || ""} />;
};

const RegionRoute = () => {
  const { slug } = useParams();
  const region = regionBySlug[slug || ""];
  return region ? <RegionPage region={region} /> : <NotFound />;
};

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="services" element={<ServicesIndex />} />
        <Route path="services/:slug" element={<ServicePage />} />
        <Route path="sectors" element={<SectorsIndex />} />
        <Route path="sectors/:slug" element={<SectorPage />} />
        <Route path="service-areas" element={<ServiceAreas />} />
        <Route path="regions" element={<RegionsIndex />} />
        <Route path="regions/:slug" element={<RegionRoute />} />
        <Route path="insights" element={<InsightsIndex />} />
        <Route path="insights/:slug" element={<InsightPage />} />
        <Route path="about" element={<About />} />
        <Route path="careers" element={<Careers />} />
        <Route path="contact" element={<Contact />} />
        <Route path="admin/login" element={<AdminLogin />} />
        <Route path="admin/applications" element={<AdminApplications />} />
        <Route path="f/how-security-personnel-protect-communities" element={<Navigate to="/insights" replace />} />
        <Route path="fr" element={<FrHome />} />
        <Route path="fr/villes" element={<FrVilles />} />
        <Route path="fr/services" element={<FrServicesIndex />} />
        <Route path="fr/services/:slug" element={<FrServicePage />} />
        <Route path="fr/:slug" element={<FrRoute />} />
        <Route path=":slug" element={<FlatResolver />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppRoutes />
      <Toaster theme="dark" position="top-right" />
    </BrowserRouter>
  );
}
